import { Spin, Tag } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";

import api from "../../../api";
import DownloadIcon from "../../../svgs/download.svg?react";
import { ZmDeclarationEntry } from "../../../types";
import { formatAmountInCents } from "../../../utils";
import { ClickableTd, H3, StyledTable } from "../VatView/styledComponents";
import { DISPLAY_DATE_FORMAT } from "@/v1/constants";

const ZmDeclarationsTable = ({
  declarations,
  email,
  loading,
}: {
  declarations: ZmDeclarationEntry[];
  email: string;
  loading: boolean;
}) => {
  const { t } = useTranslation("ZmView");
  const openPdf = async (declarationId: string) => {
    const openedWindow = window.open();
    try {
      const pdfUrl = await api.kontax.getZmDeclarationPdf(email, declarationId);
      if (openedWindow) {
        openedWindow.location.href = pdfUrl;
      }
      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 3000);
    } catch {
      openedWindow?.close();
    }
  };

  const columnCount = 6;

  if (loading) {
    return (
      <>
        <H3>{t("declarations.pastDeclarations")}</H3>
        <Spin />
      </>
    );
  }

  return (
    <>
      <H3>{t("declarations.pastDeclarations")}</H3>
      <StyledTable>
        <thead>
          <tr>
            <td>{t("declarations.amount")}</td>
            <td>{t("declarations.timePeriod")}</td>
            <td>{t("declarations.uploadedOn")}</td>
            <td>{t("declarations.type")}</td>
            <td>{t("declarations.transmission")}</td>
            <td>{t("declarations.declaration")}</td>
          </tr>
        </thead>
        <tbody>
          {declarations.length === 0 ? (
            <tr>
              <td colSpan={columnCount} style={{ textAlign: "center" }}>
                {t("declarations.noPastDeclarations")}
              </td>
            </tr>
          ) : (
            declarations.map((declaration) => (
              <tr key={declaration.id}>
                <td>{formatAmountInCents(declaration.amount ?? 0, true)}</td>
                <td>
                  {declaration.period}, {declaration.year}
                </td>
                <td>
                  {declaration.uploadedAt || declaration.createdAt
                    ? moment(
                        declaration.uploadedAt ?? declaration.createdAt
                      ).format(DISPLAY_DATE_FORMAT)
                    : "-"}
                </td>
                <td>
                  {declaration.isCorrection != null ? (
                    declaration.isCorrection ? (
                      <Tag color="orange">{t("declarations.correction")}</Tag>
                    ) : (
                      <Tag color="blue">{t("declarations.original")}</Tag>
                    )
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  {declaration.transmissionMethod === "MANUAL" ? (
                    <span>
                      {t("declarations.manual")}
                      {declaration.submitterEmail && (
                        <span style={{ color: "#888", marginLeft: 4 }}>
                          ({declaration.submitterEmail})
                        </span>
                      )}
                    </span>
                  ) : declaration.transmissionMethod === "AUTOMATIC" ? (
                    t("declarations.automatic")
                  ) : (
                    "-"
                  )}
                </td>
                <ClickableTd onClick={() => openPdf(String(declaration.id))}>
                  <DownloadIcon />
                  {` ${t("declarations.open")}`}
                </ClickableTd>
              </tr>
            ))
          )}
        </tbody>
      </StyledTable>
    </>
  );
};

export default ZmDeclarationsTable;
